/**
 * LDM · Testimonios
 * ---------------------------------------------------------------------------
 * Las flechas empujan el riel un ancho de tarjeta. El arrastre, la inercia y el
 * anclaje los resuelve el navegador con scroll-snap; aquí solo se calcula el
 * salto y se apagan las flechas en los extremos.
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.ldm-tst').forEach(function (raiz) {
      if (raiz.dataset.ldmInit === 'true') return;
      raiz.dataset.ldmInit = 'true';

      var rail = raiz.querySelector('[data-ldm-tst-rail]');
      var prev = raiz.querySelector('[data-ldm-tst-prev]');
      var next = raiz.querySelector('[data-ldm-tst-next]');
      if (!rail) return;

      function paso() {
        var card = rail.querySelector('.ldm-tst__card');
        if (!card) return rail.clientWidth * 0.8;
        var estilo = window.getComputedStyle(rail);
        var hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
        return card.getBoundingClientRect().width + hueco;
      }

      function actualizarFlechas() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          rail.scrollBy({ left: -paso(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          rail.scrollBy({ left: paso(), behavior: 'smooth' });
        });
      }

      var pendiente = false;
      rail.addEventListener(
        'scroll',
        function () {
          if (pendiente) return;
          pendiente = true;
          window.requestAnimationFrame(function () {
            actualizarFlechas();
            pendiente = false;
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', actualizarFlechas, { passive: true });
      actualizarFlechas();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
